import React, { useContext, useEffect, useRef } from "react";
import { IoMdPrint } from "react-icons/io";
import {  useLocation } from "react-router-dom";
import { ColorContext } from "../ColorContext";
import { useSelector } from "react-redux";
import LogoCollage from "../../pages/LogoCollage.jpeg"
const Dashboard = () => {


  const { isLoggedIn, loginModale, registerModale, userData } = useSelector(
    (state) => state.auth,
  );

  const handlePrint = () => {
  

    window.print();
  
    document.querySelector("#sidebar").style.display = "block";
    document.querySelector("#Dashbard-Page").style.display = "flex";
  };

  const getcourse = (course) => {
    switch (course) {
      case "2":
        return "BA";
    }
  };

  const URL = "https://campus.acetians.in/custom/uploads/";

  const Dob = String(userData?.admissions[0]?.dob);

  const day = Dob.split("-");



  const DateOfBirth = `${day[2]}-${day[1]}-${day[0]}`;

  const { bgColor } = useContext(ColorContext);

  const getSubject = String(userData?.admissions[0]?.compulsory_subjects).split(",");
  console.log(getSubject);

  const to = (s = "") =>
    s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;

  return (
    <div className="dashard">
        <button className="print-button" title="Print" onClick={handlePrint}>
            <IoMdPrint />
          </button>

      <div className="side-box">
      
        <div className="main-section-sidebar">
          <div className="Id-Card">
            <div>
              <div className="ID-Card-Header">
                <img
                  src={LogoCollage}
                  alt=""
                />
                <div>
                  <p>Government Degree College Milak Rampur (U.P.) 244922</p>
                  <span>
                    Affiliated with Guru Jambheshwar University, Moradabad
                  </span>
                </div>
              </div>
              <div className="ID-CARD-NAME">IDENTITY CARD</div>
              <div className="ID-CARD-SESSION">ACADEMIC SESSION 2025-2027</div>
              <div className="ID-Card-Details">
                <div>
                  <div>
                    <p>Admission No.</p>
                    <p>0001</p>
                  </div>
                  <div>
                    <p>URN No.</p>
                    <p>{userData?.admissions[0]?.urn}</p>
                  </div>

                  <div>
                    <p>Class</p>
                    <p>
                      {userData?.admissions[0]?.course === "1" && "Bachelor of Arts"}
                      {userData?.admissions[0]?.course === "2" && " Bachelor of Science"}
                      {userData?.admissions[0]?.course === "3" && "Bachelor Of Commerce"}
                    </p>
                  </div>
                  <div>
                    <p>Student Name.</p>
                    <p>{to(userData?.admissions[0]?.applicant_name)}</p>
                  </div>
                  <div>
                    <p>Gender</p>
                    <p>
                      {" "}
                      {userData?.admissions[0]?.gender === 1 && "Male"}{" "}
                      {userData?.admissions[0]?.gender === 2 && "Female"}{" "}
                      {userData?.admissions[0]?.gender === 3 && "Other"}
                    </p>
                  </div>

                  <div>
                    <p>Fathers Name</p>
                    <p>{to(userData?.admissions[0]?.father_name)}</p>
                  </div>
                  <div>
                    <p>Mothers Name</p>
                    <p>{to(userData?.admissions[0]?.mother_name)}</p>
                  </div>
                </div>
                <div>
                  <img
                    src={
                      `${URL}${userData?.admissions[0]?.image_file}` ||
                      "https://www.pngitem.com/pimgs/m/272-2720656_user-profile-dummy-hd-png-download.png"
                    }
                    alt="student image"
                  />
                </div>
              </div>
              <div className="Auth-Section">
                <div>Signature of Student</div>

                <div>Chief Proctor</div>
              </div>
            </div>
            <div>
              <div className="ID-Card-Header">
                <img
                  src={LogoCollage}
                  alt=""
                />
                <div>
                  <p>Government Degree College Milak Rampur (U.P.) 244922</p>
                  <span>
                    Affiliated with Guru Jambheshwar University, Moradabad
                  </span>
                </div>
              </div>

              <div className="ID-Card-back-Details">
                <div>
                  <p>Date Of Birth</p>
                  <p>{DateOfBirth}</p>
                </div>
                <div>
                  <p>Blood Group</p>
                  <p>{userData?.admissions[0]?.bloodGroup || "NA"}</p>
                </div>

                <div>
                  <p>Contact No.</p>
                  <p>{userData?.admissions[0]?.applicant_mobile}</p>
                </div>
                <div>
                  <p>Aadhar No.</p>
                  <p>{userData?.admissions[0]?.aadhar}</p>
                </div>
                <div>
                  <p>Email Id.</p>
                  <p>{userData?.admissions[0]?.applicant_email || "NA"}</p>
                </div>
                <div>
                  <p>Address</p>
                  <p>{to(userData?.admissions[0]?.p_address)}</p>
                </div>
                <div>
                  <p>Major Subject 1</p>
                  <p>{getSubject[0]}</p>
                </div>
                <div>
                  <p>Major Subject 2</p>
                  <p>{getSubject[1]}</p>
                </div>
                <div>
                  <p>Minor Subject</p>
                  <p>{getSubject[2]}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
